// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".service-modal{border-radius:24px}.service-modal__close{background:rgba(0,0,0,.7);position:absolute;right:10px;top:10px;z-index:1}.service-modal__image{display:block}.service-modal__image img{max-width:100%}.service-modal__card{margin:auto;overflow:hidden;position:relative;width:-moz-fit-content;width:fit-content}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
